/*! @azure/msal-common v9.0.2 2023-01-10 */
'use strict';
/* eslint-disable header/header */
var name = "@azure/msal-common";
var version = "9.0.2";

export { name, version };
//# sourceMappingURL=packageMetadata.js.map
